import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Philosophy from "@/components/site/Philosophy";
import Curriculum from "@/components/site/Curriculum";
import Projects from "@/components/site/Projects";
import TechStack from "@/components/site/TechStack";
import Instructor from "@/components/site/Instructor";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-slate-900" data-testid="landing-page">
      <Nav />
      <main>
        <Hero />
        <Philosophy />
        <Curriculum />
        <Projects />
        <TechStack />
        <Instructor />
      </main>
      <Footer />
    </div>
  );
}
